export default __webpack_public_path__ + "static/media/Terms.bc9b5a02.pdf";